import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiKeyHeader } from "../../../../../configs/ApiKeys";
import { lessonPlanner } from "../../../../../configs/WebService";

export const fetchMyHomeworks = createAsyncThunk(
  "homeworks/fetchMyHomeworks",
  async (teacherId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${lessonPlanner}/getteacher_homeworks/${teacherId}`,
        { headers: apiKeyHeader() }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
